module.exports = __webpack_public_path__ + "static/media/cc_master.6c261aee.png";